import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Allow callers to override Authorization
  if (config.headers && config.headers.Authorization) return config;
  // Admin token by default for admin routes; member token for member routes
  const adminToken = localStorage.getItem("godsc_token");
  const memberToken = localStorage.getItem("godsc_member_token");
  const url = config.url || "";
  config.headers = config.headers || {};
  if (url.startsWith("/members/me") || url.startsWith("/members/dues/")) {
    if (memberToken) config.headers.Authorization = `Bearer ${memberToken}`;
  } else if (adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
